export default "__VITE_ASSET__BRd5tV78__"